import { ActionEvent, IPhysicsCollisionEvent } from '@babylonjs/core';
import { Level } from './Level';
import { Player } from './Player';

export class PlayerCollision {
  constructor(
    public disableCollision: boolean,
    public action?: (level: Level, player: Player, event: ActionEvent | IPhysicsCollisionEvent) => void,
    public physics: boolean = true
  ) {}
}
